// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".deleteConfirmContent--55AE8v6G strong {\n    padding-left: 3px;\n    padding-right: 3px;\n    color: #fc5043;\n    font-weight: normal;\n    background-color: #ffeeed;\n    border-radius: 2px;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteConfirmContent": "deleteConfirmContent--55AE8v6G"
};
export default ___CSS_LOADER_EXPORT___;
